import { getBookWithMeModule } from 'bookwithme-routes';
import { getOrganizerMeetingTypeId } from 'bookwithme-organizer';
import {
    getCurrentMeetingTypeId,
    getBookingMeetingTypeId,
    getBookingMailbox,
    getUrlBookingId,
} from 'bookwithme-attendee';
import {
    ORGANIZER_PAGE_KEYWORD,
    MEETING_TYPE_ROUTE_KEYWORD,
    ORGANIZER_NEW_MEETING_TYPE_ROUTE_KEYWORD,
    ATTENDEE_PAGE_KEYWORD,
    ATTENDEE_MEETING_DETAILS_ROUTE_KEYWORD,
} from 'bookwithme-shared/lib/store/schema/BookWithMeRouteConstants';

// pushes route in window object
export default function getCurrentRoute() {
    const route: string[] = [];
    const currentModule = getBookWithMeModule();

    switch (currentModule) {
        case 'Organizer':
            route.push(ORGANIZER_PAGE_KEYWORD);
            break;
        case 'Compose':
            const organizerMeetingTypeId = getOrganizerMeetingTypeId();
            if (organizerMeetingTypeId) {
                route.push(
                    ORGANIZER_PAGE_KEYWORD,
                    MEETING_TYPE_ROUTE_KEYWORD,
                    organizerMeetingTypeId
                );
            } else {
                route.push(
                    ORGANIZER_PAGE_KEYWORD,
                    MEETING_TYPE_ROUTE_KEYWORD,
                    ORGANIZER_NEW_MEETING_TYPE_ROUTE_KEYWORD
                );
            }
            break;
        case 'Attendee':
            const bookingMailbox = getBookingMailbox();
            if (bookingMailbox) {
                const attendeeMeetingTypeId =
                    getCurrentMeetingTypeId() ?? getBookingMeetingTypeId();
                if (attendeeMeetingTypeId) {
                    route.push(
                        ATTENDEE_PAGE_KEYWORD,
                        bookingMailbox,
                        MEETING_TYPE_ROUTE_KEYWORD,
                        attendeeMeetingTypeId
                    );
                } else {
                    route.push(ATTENDEE_PAGE_KEYWORD, bookingMailbox);
                }
            }
            break;
        case 'MeetingDetails':
            const meetingDetailsMailbox = getBookingMailbox();
            const bookingId = getUrlBookingId();
            if (meetingDetailsMailbox && bookingId) {
                route.push(
                    ATTENDEE_PAGE_KEYWORD,
                    meetingDetailsMailbox,
                    ATTENDEE_MEETING_DETAILS_ROUTE_KEYWORD,
                    bookingId
                );
            }
            break;
        default:
            break;
    }
    return route;
}
